<!--
 * @Author: wsx
 * @Date: 2022-01-05 18:45:47
 * @LastEditTime: 2022-01-12 18:03:34
 * @LastEditors: your name
 * @Description:穿梭框应用
-->
<template>
  <el-dialog
    v-model="formVisible"
    :title="title"
    width="50%"
    @close="closeDialog"
  >
    <div class="TransferApplication" v-loading="loading" v-show="!mapActive">
      <h-transfer
        ref="transferRef"
        v-model="transferKeys"
        :nodeKey="nodeKey"
        :checkedKey="checkedKey"
        :props="{ value: 'treeId', label: 'name' }"
        :data="treeData"
        :default-expanded-keys="[rootNodeKey]"
        :areaCameraArry="areaCameraArry"
        :titles="['待选', '已选']"
        :showDefineTree="true"
      >
      </h-transfer>
    </div>
    <mapSelectTransfer
      class="box-map"
      ref="mapSelectRef"
      v-if="mapActive"
      :allCameraList="videoData.cameraBaseDtls"
    ></mapSelectTransfer>
    <template #footer>
      <span class="dialog-footer">
        <div
          class="map"
          @click="changeMapActive"
          v-show="dataType === '摄像机'"
        >
          <h-icon icon="icon-weizhi" font-size="16"></h-icon
          >{{ !mapActive ? "地图选择" : "资源树选择" }}
        </div>
        <h-button type="primary" @click="emitCheckList">确定</h-button>
        <!-- <h-button @click=" = false">取消</h-button> -->
      </span>
    </template>
  </el-dialog>
</template>
<script>
import {
  defineComponent,
  reactive,
  toRefs,
  watchEffect,
  ref,
  onMounted,
  nextTick,
} from "vue";
import { toRaw } from "@vue/reactivity";
import {
  queryOrganPersonList,
  queryOrganListId,
  queryOrganList,
} from "@/api/system";
import {
  queryRealVideoTree,
  queryTreeAreaVideo,
} from "@/api/videoControl/videoApi.js";
import { videoFilesList } from "@/api/smartApplication/smartApplicationApi.js";
import { getMenutree } from "@/api/system/region.js";
import util from "@util/js";
import { ElMessage } from "element-plus";
export default defineComponent({
  emits: [
    "transferApplicationList",
    "update:visible",
    "closeDialog",
    "clickMap",
  ],
  name: "TransferApplication",
  components: {},
  props: {
    icon: {
      type: String,
    },
    elIcon: {
      type: String,
    },
    fontSize: {
      type: String,
      default: "16px",
    },
    title: {
      type: String,
      default: "摄像机选择",
    },
    // 展示弹窗
    visible: {
      type: Boolean,
      default: false,
    },
    // 视图解析中解析任务类型
    dataType: {
      type: String,
      default: "摄像机",
    },
    // 弹框下有地图。不展示弹框中地图
    backMap: {
      type: Boolean,
      default: false,
    },
    // 传进来Ids直接渲染
    deviceIds: {
      type: Object,
      default: [],
    },
  },
  setup(props, context) {
    const data = reactive({
      loading: false,
      mapActive: false,
      areaCameraArryObj: [], // 区域内绑定摄像头   存摄像头对象
      areaCameraArry: [], // 区域内绑定摄像头  存摄像头ID
      checkedKey: "cameraId", // 根据此字段获取选中的数据
      nodeKey: "cameraId", // 根据此字段获取选中的数据
      transferKeys: [],
      treeOrganPerson: [],
      rootNodeKey: "",
      videoData: null,
      treeData: [],
      formVisible: false,
      asyncType: "",
    });
    const refData = toRefs(data);
    const mapSelectRef = ref();
    const transferRef = ref();
    // 使用wache监听不报红
    watchEffect(() => {
      data.formVisible = props.visible;
      console.log(data.formVisible);
    });
    watchEffect(() => {
      if (props.dataType)
        nextTick(() => {
          queryOrganPersonListAsycn();
          if (transferRef.value) transferRef.value.selectedList = [];
        });
    });
    // 获取区域树数据
    const queryOrganPersonListAsycn = async () => {
      let result;
      if (props.dataType === "摄像机") {
        result = await getMenutree();
        const treeData = [result.data];
        data.treeOrganPerson = treeData;
        data.checkedKey = "cameraId";
        data.nodeKey = "cameraId";
        queryRealVideoTreeAsync();
      } else if (props.dataType === "视频") {
        result = await videoFilesList({});
        changeListName(result.page.list, "fileName");
        data.treeData = result.page.list;
        data.checkedKey = "id";
        data.nodeKey = "id";
      }
    };
    // 获取区域树中所有摄像头数据
    const queryRealVideoTreeAsync = async () => {
      data.loading = true;
      // const res = await queryRealVideoTree();
      // const params = {
      //   areaId: value.id,
      // };
      const res = await queryTreeAreaVideo();
      data.videoData = res;
      const arrayGroup = arrayGroupBy(data.videoData.cameraBaseDtls, "areaId");
      const changeArrayGroup = {};
      arrayGroup.forEach((item) => {
        item.forEach((it) => {
          it.name = it.cameraName;
          it.treeId = "device_" + it.deviceId;
        });
        changeArrayGroup[item[0].areaId] = item;
      });
      console.log(changeArrayGroupArray);
      const changeArrayGroupArray = Object.keys(changeArrayGroup);
      console.log(changeArrayGroupArray);
      const getChildren = (obj) => {
        for (const key in obj) {
          if (key == "children") {
            obj[key].forEach((item) => {
              getChildren(item);
              if (changeArrayGroupArray.includes(item.id + "")) {
                changeArrayGroup[item.id].forEach((it) => {
                  item.children.push(it);
                });
              }
            });
          }
        }
      };
      getChildren(data.treeOrganPerson[0]);
      console.log(data.treeOrganPerson);
      data.treeData = data.treeOrganPerson;
      //处理父组件传进来直接渲染的
      if (props.deviceIds.length > 0) {
        setTimeout(() => {
          handleAreaCamera(props.deviceIds);
        });
      }
      data.loading = false;
    };
    const emitCheckList = () => {
      context.emit("update:visible", false);
      if (!data.mapActive) {
        context.emit("transferApplicationList", data.transferKeys);
      } else {
        context.emit("transferApplicationList", mapSelectRef.value.selectPoint);
      }
    };
    const arrayGroupBy = (list, groupId) => {
      const sorted = groupBy(list, (item) => {
        return [item[groupId]];
      });
      return sorted;
    };
    const groupBy = (arr, f) => {
      const groups = {};
      arr.forEach((o) => {
        const group = JSON.stringify(f(o));
        groups[group] = groups[group] || [];
        groups[group].push(o);
      });
      return Object.keys(groups).map((group) => {
        return groups[group];
      });
    };
    const closeDialog = () => {
      context.emit("update:visible", false);
      context.emit("closeDialog");
    };
    const changeMapActive = () => {
      if (data.loading) {
        ElMessage.warning("请稍等正在加载数据");
        return;
      }
      if (props.backMap) {
        ElMessage.warning("请在当前地图选择摄像头");
        closeDialog();
        context.emit("clickMap");
        return;
      }
      data.mapActive = !data.mapActive;
      data.areaCameraArryObj =
        transferRef.value && transferRef.value.selectedList;
    };
    //添加穿梭框需要渲染的属性名
    const changeListName = (list, str) => {
      list.forEach((item) => {
        item.name = item[str];
      });
    };
    // 处理外部传进来deviceId，根据id渲染已选中
    const handleAreaCamera = (deviceId) => {
      const newCheckedNodeArray = [];
      const deviceIdToAll = [];
      data.videoData.cameraBaseDtls.forEach((item) => {
        if (deviceId.includes(item.deviceId)) {
          deviceIdToAll.push(item);
        }
      });
      data.areaCameraArry = deviceIdToAll.map((item) => {
        return (item = JSON.parse(
          JSON.stringify(item).replace(/cameraName/g, "resourceName")
        ));
      });
      data.areaCameraArry.forEach((item) => {
        newCheckedNodeArray.push(item.cameraId);
      });
      data.areaCameraArry = newCheckedNodeArray;
      data.rootNodeKey = data.areaCameraArry[0];
    };
    // queryOrganPersonListAsycn();
    return {
      ...refData,
      transferRef,
      emitCheckList,
      closeDialog,
      mapSelectRef,
      changeMapActive,
    };
  },
});
</script>
<style lang="scss" scoped>
.el-dialog {
  position: relative;
  .TransferApplication {
    height: 50vh;
  }
  .box-map {
    height: 50vh;
  }
  .dialog-footer {
    width: 100%;
    padding-bottom: 8px;

    .map {
      position: absolute;
      left: 0;
      width: 150px;
      font-size: 16px;
      line-height: 34px;
      color: brown;
      cursor: pointer;
    }
  }
}
</style>
